// removed by extract-text-webpack-plugin
module.exports = {"base":"src-layouts-ImageList----ImageList-module---base---8l3s8","wrapper":"src-layouts-ImageList----ImageList-module---wrapper---3_Pve"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ImageList/ImageList.module.scss
// module id = 350
// module chunks = 35783957827783